module.exports = __webpack_public_path__ + "img/trade.c8c9a587.png";